import ResizeDetector from "./components/ResizeDetector";
import withResizeDetector from "./hoc/withResizeDetector";
export { withResizeDetector };
export default ResizeDetector;